
import { Link } from "react-router-dom";
import { ProductCard } from "@/components/ProductCard";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const AudioOptions = () => {
  const { t } = useLanguage();
  
  const options = [
    {
      id: "dsps",
      name: t('digital.signal.processors'),
      description: t('dsps.description'),
      image: "/lovable-uploads/3ab44682-1c92-4d7a-b99f-7e665e65c005.png",
      slug: "audio-dsps"
    },
    {
      id: "amplifiers",
      name: t('amplifiers'),
      description: t('amplifiers.description'),
      image: "/lovable-uploads/de5193b2-fbb5-4c77-b24b-c9d23fab4012.png",
      slug: "audio-amplifiers"
    },
    {
      id: "speakers",
      name: t('speakers'),
      description: t('speakers.description'),
      image: "/lovable-uploads/5391e8e2-c10c-40c8-b763-3fb1e0116199.png",
      slug: "audio-speakers"
    }
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="mb-8">
        <Link
          to="/"
          className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('back.to.categories')}
        </Link>
        <h1 className="mb-4 text-3xl font-bold tracking-tight">
          {t('audio.solutions')}
        </h1>
        <p className="text-lg text-muted-foreground">
          {t('choose.audio.solution')}
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
        {options.map((option) => (
          <ProductCard
            key={option.id}
            title={option.name}
            description={option.description}
            image={option.image}
            link={`/group/${option.slug}`}
            className="animate-fade-up"
            showVPXLogos={option.id === "dsps" || option.id === "amplifiers"}
          />
        ))}
      </div>
    </div>
  );
};

export default AudioOptions;
